import Ticket from "@/types/Ticket";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/atoms/Accordion";
import QualityAssigneeForm from "./QualityAssigneeForm";
import TechnicalQualityForm from "./TechnicalQualityForm";
import ProcessQualityFrom from "./ProcessQualityForm";

type Props = {
  ticket: Ticket;
  setSelectedTicketStatus: (status: string) => void;
  qualityTickets: any[];
  users: any[];
};

const QualityTab = ({ ticket, setSelectedTicketStatus, qualityTickets, users }: Props) => {
  return (
    <div className="p-10">
      <Accordion
      className="w-full pt-4 pb-4"
      type="single"
      defaultValue=""
      collapsible
    >
      {ticket.status.id !== 6 && (
        <AccordionItem value="qualityAssignee" className="shadow px-5 mb-5 border border-border rounded">
          <AccordionTrigger className="text-md font-semibold">QA Details</AccordionTrigger>
          <AccordionContent>
            <QualityAssigneeForm ticket ={ticket} setSelectedTicketStatus={setSelectedTicketStatus} qualityTickets={qualityTickets} users={users} />
          </AccordionContent>
        </AccordionItem>
      )}
      
      <AccordionItem value="technicalQuality" className="shadow px-5 mb-5 border border-border rounded">
        <AccordionTrigger className="text-md font-semibold">Technical Quality</AccordionTrigger>
        <AccordionContent>
          <TechnicalQualityForm ticket ={ticket} setSelectedTicketStatus={setSelectedTicketStatus} qualityTickets={qualityTickets}/>
        </AccordionContent>
      </AccordionItem>

      {ticket.status.id === 6 && (
        <AccordionItem value="processQuality" className="shadow px-5 mb-5 border border-border">
          <AccordionTrigger className="text-md font-semibold">Process Quality</AccordionTrigger>
          <AccordionContent>
            <ProcessQualityFrom ticket ={ticket} qualityTickets={qualityTickets}/>
          </AccordionContent>
        </AccordionItem>
      )}
    </Accordion>
    </div>
    
  );
};

export default QualityTab;
